import type { RootState } from "../store/store";
import { useSelector } from "react-redux";
import { getParameter } from "../store/app/general";
import DatepickerInput from "../components/elements/datepicker/datepicker";
import StationPicker from "../components/elements/stationpicker/stationpicker";
import ORMfunctions from "../hooks/app/general";

function Searchbar(props: any) {
  const deliveryStation = useSelector((state: RootState) =>
    getParameter(state, "BINET_ALLOW_ONEWAY"),
  );
  const options = useSelector(
    (state: RootState) => state.general.stationpickerOptions,
  );

  return (
    <div className="orm-html" data-symbol={props.symbol}>
      <div className="orm-searchbar__datepicker orm-searchbar__datepicker--wrappless">
        <div className="orm-searchbar__padding">
          <div className="orm-row center-lg">
            <div className="orm-col orm-col-flex-1">
              <div className="orm-searchbar__headline">
                <strong>Station</strong>
              </div>
              <div className="orm-row">
                <div className="orm-col-xs-12 orm-col-lg-12">
                  <StationPicker
                    type="start"
                    useinputsearch={options.useinputsearch}
                    useapi={options.useapi}
                    regioncodes={options.regioncodes}
                    rangelimit={options.rangelimit}
                    resultlimit={options.resultlimit}
                  />
                </div>
                <div className="orm-col-xs-12 orm-col-lg-12">
                  {deliveryStation ? (
                    <StationPicker
                      type="end"
                      useinputsearch={options.useinputsearch}
                      useapi={options.useapi}
                      regioncodes={options.regioncodes}
                      rangelimit={options.rangelimit}
                      resultlimit={options.resultlimit}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
            <div className="orm-relative orm-col-flex-2">
              <DatepickerInput />
            </div>
            <div className="text-right orm-col orm-col-flex-1">
              <div className="orm-searchbar__headline">
                <strong>&nbsp;</strong>
              </div>
              <button
                className="orm-btn orm-btn--large orm-btn--searchbar"
                onClick={() => {
                  window.location.href =
                    ORMfunctions.baseLang() + "/reservation/step1";
                }}
              >
                suchen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Searchbar;
